/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */

'use strict';
const CheckErrorsPopupForm = {
	$domMessageErrorSelector: $('.popup__message>.gform_validation_error>.gform_validation_errors'),
	$domSignupErrorSelector: $('.popup__user>.gform_validation_error>.gform_validation_errors'),
	$domSignupSubmitSelector: $('.popup__user>.gform_confirmation_wrapper>.gform_confirmation_message>.thank-you-popup'),
	$domMessageSubmitSelector: $('.popup__message>.gform_confirmation_wrapper>.gform_confirmation_message>.thank-you-popup'),
	init: function() {
		this.checkErrors();
	},

	checkErrors: function() {
		const registerError = document.querySelector('.js-popup-register-form');
		const messageError = document.querySelector('.js-popup-message-form');
		if (this.$domSignupErrorSelector[0]){
			registerError.click();
		}else if (this.$domMessageErrorSelector[0]){
			messageError.click();
		}else if (this.$domSignupSubmitSelector[0]) {
			registerError.click();
		}else if (this.$domMessageSubmitSelector[0]) {
			messageError.click();
		}
	},
};

export default CheckErrorsPopupForm;
